/**
 * The one spelling of the suite bar's click event.
 *
 * The package deliberately ships no analytics SDK. Bundling one would run a second
 * instance alongside the host's — racing it on device id and session — and would emit
 * without the host's identity or consent handling, producing clicks that cannot be joined
 * to users. Transport, identity and consent stay with the host; only the event's shape
 * lives here.
 *
 * What that leaves is a drift risk, and it is the whole reason this helper exists: a
 * satellite that hand-writes `app_id` instead of `target_app_id`, or renames the event,
 * silently splits the fleet-wide chart rather than failing. Name and properties travel
 * together as one value so the two cannot be paired wrongly.
 */
const SUITE_NAV_CLICK_EVENT = 'suite_nav_app_clicked';
/**
 * Builds the event as a `[name, properties]` pair, ready to spread into a tracker:
 *
 * ```ts
 * onAppClick={(args) => amplitude.track(...suiteNavClickEvent(args, 'art_books'))}
 * ```
 *
 * `TSource` is generic so the literal survives: a host whose tracker types `source_app` as
 * a union of known apps still typechecks, which a widened `string` would not.
 */
function suiteNavClickEvent(args, sourceApp) {
    return [SUITE_NAV_CLICK_EVENT, { target_app_id: args.app.id, source_app: sourceApp, collapsed: args.collapsed }];
}
export { SUITE_NAV_CLICK_EVENT, suiteNavClickEvent };
//# sourceMappingURL=analytics.js.map